import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, last } from 'rxjs/operators';
import { Cliente } from 'src/app/models/cliente';

@Injectable({
  providedIn: 'root'
})

export class HistoricoConsultaService {

  constructor(private httpClient: HttpClient) {}

  getHistoricoGeral(data, ignore:string[]) {
    return this.httpClient.post< { lista, total: number } >(environment.wsUrl + 'relatorio/listaGeralConsultaUnidadeCliente', data,
    {params: {
      ignore: ignore
    }}).pipe(
      last(),
      map(result => {
        return {lista: result.lista, total: result.total, filter: data}
      })
    ).toPromise();
  }

  getHistoricoCliente(data, ignore:string[]) {
    return this.httpClient.post< { lista, total: number } >(environment.wsUrl + 'relatorio/lista', data,
    { params: { ignore: ignore } }).pipe(
      last(),
      map(result => {
        return {lista: result.lista, total: result.total, filter: data}
      })
    ).toPromise();
  }

  getlistaClientes(ignore = []) {
    return this.httpClient.get<Cliente[]>(environment.wsUrl + 'unidade/listaNomeFantasiaUnidadeCliente',
    { params: { ignore: ignore } }).pipe(
      map(result => result.map(c => new Cliente(c)))
    ).toPromise();
  }

}
